import { Routes } from '@angular/router';
import { searchFilterIndex } from '../search/search-filter-index/search-filter-index.routes';

export const dashboardPages: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: 'home',
    loadComponent: () => import('../home/home.page').then((m) => m.HomePage),
  },
  {
    path: 'search',
    children: searchFilterIndex,
    loadComponent: () => import('../search/search-filter-index/search-filter-index.page').then(m => m.SearchFilterIndexPage)
  },
  {
    path: 'orders',
    loadComponent: () => import('../my-orders/index/index.page').then(m => m.IndexPage)
  },
  {
    path: 'cart',
    loadComponent: () =>
      import('../cart/cart.page').then((m) => m.CartPage),
  },
  {
    path: 'checkout',
    loadComponent: () => import('../checkout/checkout.page').then(m => m.CheckoutPage)
  },
  {
    path: 'order/:id',
    loadComponent: () => import('../order/order.page').then(m => m.OrderPage)
  },
  {
    path: 'distributor',
    loadComponent: () => import('../informations/distributors/distributors.page').then(m => m.DistributorsPage)
  },
  {
    path: 'wallet',
    loadComponent: () => import('../settings/wallet/wallet.page').then(m => m.WalletPage)
  },
  {
    path: 'validation',
    loadComponent: () => import('../validation/validation.page').then(m => m.ValidationPage)
  },
  {
    path: 'report-fake',
    loadComponent: () => import('../report/report.page').then(m => m.ReportPage)
  },
  {
    path: 'shipping-address',
    loadComponent: () => import('../settings/shipping-address/shipping-address.page').then(m => m.ShippingAddressPage)
  },
  {
    path: 'personal-info',
    loadComponent: () => import('../settings/personal-info/personal-info.page').then(m => m.PersonalInfoPage)
  },
  {
    path: 'user-profile',
    loadComponent: () => import('../settings/user-profile/user-profile.page').then(m => m.UserProfilePage)
  },
  {
    path: 'info/:page',
    loadComponent: () => import('../informations/info/info.page').then(m => m.InfoPage)
  },
]
